module.exports = __webpack_public_path__ + "img/d201003-2.3f2ac319.jpg";